import { useState } from 'react'
import { Button, Alert } from "react-bootstrap";
import { serGetNameNum } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';



export default function Screening() {
  // 查询全部数据展示列表
  const [backdata,setBackData]=useState([]);
  const [msgInfo,setMsgInfo]=useState('');

  const {lg}=useSelector((state)=>state.language)

  const handleBtnClick=() => {
    serGetNameNum({})
    .then(res=>{
      const code=res.code;
      if(code===44){
        setBackData(res.data+'')
      }else{
        setMsgInfo(`0${langList.screening20[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    })
  };

  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )
  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };

  return (
    <div>
      <div className='d-flex justify-content-between mt-4 mb-3'>
        <Button variant="primary"
          onClick={handleBtnClick}
        >{langList.public10[lg]}</Button>
        <div>{backdata}</div>
      </div>
      {true && chip}
    </div>
  );
}
